/**
 * LiveFlight Selection Module
 * Handles selected flight offer and baggage options
 */

/**
 * Selection state properties
 */
export const state = {
  // Selected flight
  flight_offer: {},
  flight_offer_has_upsell: false,

  // Baggage
  bags: {},
  flexible_bags: {},
  has_flexible_bags_last_selection: false,
};

/**
 * Custom mutations for selection state
 */
export const mutations = {
  // Reset selection state
  reset_selection(state) {
    state.flight_offer = {};
    state.bags = {};
    state.flexible_bags = {};
  },

  // Atomic mutation: selects a flight offer and resets all dependent state in a single commit.
  // Prevents 5 separate subscribe handler calls (localStorage writes).
  select_flight_offer(state, flight_offer) {
    state.bags = {};
    state.flexible_bags = {};
    state.traveler_details = [];
    state.contact_details = {};
    state.flight_offer = flight_offer;
  },
};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = [
  "flight_offer",
  "bags",
  "flexible_bags",
  "has_flexible_bags_last_selection",
];
